export { AppModule } from './app.module';



// WEBPACK FOOTER //
// ./src/app/index.ts